import React from 'react';

// Wiederverwendbarer Footer mit Impressum-Link für öffentliche Seiten.
// Das Impressum muss von jeder öffentlich erreichbaren Seite leicht auffindbar sein (§ 5 DDG).
function ImpressumFooter() {
  return (
    <footer className="text-center py-3">
      <a href="/impressum" className="text-white text-decoration-none" style={{ fontSize: '0.9rem', opacity: 0.85 }}>
        Impressum
      </a>
    </footer>
  );
}

export default ImpressumFooter;
